<script setup lang="ts">
import { ref } from 'vue'; // Import ref
import Desktop from './Desktop.vue'
import Registry from './Registry.vue'
import HoeppnerButton from './HoeppnerButton.vue'
import { LogOut } from "lucide-vue-next";

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { get_data_attr } from '@/utils/globals'

import { useViewStore } from '@/stores/viewStore'

const viewStore = useViewStore();

const userInfo = get_data_attr("user");
const customerInfo = get_data_attr("customer");

const specsInfo = ref(get_data_attr("specs"));

async function reset() {
  try {
    const response = await fetch('/specsinfo'); 
    
    if (!response.ok) throw new Error('Network response was not ok');
    
    const newData = await response.json();
    
    specsInfo.value = newData;
    
    console.log("specsInfo updated successfully");
  } catch (error) {
    console.error("Failed to reset specsInfo:", error);
  }
}
</script>

<template>
    <Desktop 
      v-if="viewStore.isViewDesktop()" 
      :userInfo="userInfo" 
      :customerInfo="customerInfo" 
      :specsInfo="specsInfo"
    >
      <div class="w-1/2 flex flex-col justify-top">
        <Card class="w-full max-w-sm hoeppner-bg">
          <CardHeader>
            <CardTitle class="text-center">
              Herzlich willkommen, {{userInfo.firstname + " " + userInfo.lastname}}.
            </CardTitle>
          </CardHeader>
          <CardContent>
            Sie haben sich efolgreich auf hoeppner-online.de eingeloggt...
          </CardContent>
        </Card>
        <HoeppnerButton text="Ausloggen" url="/logout" width="150px" marginClass="mt-2">
          <LogOut />
        </HoeppnerButton>
      </div>
    </Desktop>

    <Registry 
      v-if="viewStore.isViewRegistry() && specsInfo && Object.keys(specsInfo).length > 0"
      :userInfo="userInfo" 
      :customerInfo="customerInfo" 
      :specsInfo="specsInfo" 
      @reset="reset" 
    />
</template>